const userPermission = {
	CAN_WRITE_USER: "canWriteUser",
};

export default userPermission;
